import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';


const Input = styled(MuiInput)`
  width: 42px;
`;

export default function InputSlider({ label, name, min, max, step, startValue, handleValueChanged, disable }) {
    const [value, setValue] = React.useState(startValue);

    const handleSliderChange = (evt) => {
        setValue(evt.target.value);
    };

    const handleInputChange = (evt) => {
        setValue(evt.target.value === '' ? '' : Number(evt.target.value));
        handleValueChanged(Number(evt.target.value));
    };

    const handleBlur = () => {
        if (value < min) {
            setValue(min);
        } else if (value > max) {
            setValue(max);
        }
    };

    return (
        <Box
            sx={
                {
                    boxShadow: '1px 1px 3px 1px rgb(191, 191, 191)',
                    border: '1px solid rgb(122, 122, 122)',
                    borderRadius: '8px',
                    padding: 1,
                    '&:hover': {
                        borderColor: 'black',
                    },
                    height: 70
                }
            }
        >
            <Typography style={{ fontSize: '16px' }} id="input-slider">
                {label}
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        step={step}
                        min={min}
                        max={max}
                        disabled={disable}
                        style={{ marginLeft: '10px' }}

                    />
                </Grid>
                <Grid item>
                    <Input
                        sx={{ width: 40, marginBottom: '5px' }}
                        value={value}
                        size='small'
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        name={name}
                        disabled={disable}
                        inputProps={{
                            step: step,
                            min: min,
                            max: max,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}